import React, { useEffect, useState } from 'react';
import api from '../../axios/api';
import { Box, Link } from '@mui/material';
import Grid from '../common/Grid';

const TopUsersTable = () => {
  const [users, setUsers] = useState([]);
  const [totalCounts, setTotalCounts] = useState({ totalPosts: 0, totalVerified: 0, totalPoints: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTopUsers = async () => {
      try {
        setLoading(true);
        const response = await api.get('/api/User/topUsers');
        const data = response.data || [];
        setUsers(data);

        // Calculate totals
        let totalPosts = 0;
        let totalVerified = 0;
        let totalPoints = 0;
        data.forEach((user) => {
          totalPosts += parseInt(user.totalTrees || 0, 10);
          totalVerified += parseInt(user.verifiedTrees || 0, 10);
          totalPoints += parseInt(user.redeemed_points || 0, 10);
        });

        setTotalCounts({ totalPosts, totalVerified, totalPoints });
      } catch (error) {
        console.error('Error fetching top users:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTopUsers();
  }, []);

  const columns = [
    {
      header: 'Profile',
      width: '80px',
      align: 'center',
      render: (_, user) => (
        <Link 
          href={`/userprofile/${user.id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Box
            component="img"
            src={user.userProfilePic || '/images/icon/user.png'}
            alt={user.userName || user.full_name}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/images/icon/user.png';
            }}
            sx={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              objectFit: 'cover',
              display: 'inline-block',
              transition: 'transform 0.3s, box-shadow 0.3s',
              '&:hover': {
                transform: 'scale(1.25)',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
              }
            }}
          />
        </Link>
      ),
    },
    {
      header: 'Name',
      accessor: 'full_name',
      sortable: true,
      render: (val, user) => (
        <Link
          href={`/userprofile/${user.id}`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontWeight: 'bold',
            textDecoration: 'none',
            color: 'inherit',
            '&:hover': { color: '#002F43', textDecoration: 'underline' }
          }}
        >
          {val || user.userName}
        </Link>
      ),
    },
    {
      header: 'Plants',
      accessor: 'totalTrees',
      sortable: true,
      align: 'center',
      render: (val) => val ?? 0,
    },
    {
      header: 'Verified',
      accessor: 'verifiedTrees',
      sortable: true,
      align: 'center',
      render: (val) => val ?? 0,
    },
    {
      header: 'Reward Points Earned',
      accessor: 'redeemed_points',
      sortable: true,
      align: 'center',
      render: (val) => val ?? 0,
    },
  ];

  return (
    <Box sx={{ padding: '30px 15px', }}>
      <h1 style={{ textAlign: 'center'}}>Leaders</h1>
      <Grid
        columns={columns}
        data={users}
        loading={loading}
        variant="navy"
        // pagination={true}
        pageSize={10}
        // pageSizeOptions={[5, 10, 20, 50]}
        rowKey="id"
        footer={[
          { content: 'Total', align: 'left', style: { fontWeight: 'bold',color:"black" } },
          { content: '' },
          { content: totalCounts.totalPosts, align: 'center', style: { fontWeight: 'bold',color:"black" } },
          { content: totalCounts.totalVerified, align: 'center', style: { fontWeight: 'bold',color:"black" } },
          { content: totalCounts.totalPoints, align: 'center', style: { fontWeight: 'bold',color:"black" } },
        ]}
      />
    </Box>
  );
};

export default TopUsersTable;